export default {
  data() {
    return {
      enabled: false,
      the_feed: null,
    };
  },
  methods: {
    toggleEnabled() {
      if (this.enabled) {
        this.enablePodcastWebsite();
      } else {
        this.disablePodcastWebsite();
      }
    },
    async enablePodcastWebsite() {
      try {
        const response = await axios.post(`/api/v1/podcast-websites/${this.the_feed.uuid}`);
        this.podcast_website = response.data.data;
      } catch (error) {
        this.enabled = false;
        window.handleAxiosError(error);
      }
    },
    async disablePodcastWebsite() {
      try {
        await axios.delete(`/api/v1/podcast-websites/${this.podcast_website.id}`);
        this.podcast_website = null;
      } catch (error) {
        this.enabled = true;
        window.handleAxiosError(error);
      }
    },
    async getPodcastWebsite(feed_uuid) {
      try {
        const response = await axios.get(`/api/v1/podcast-websites/feed/${feed_uuid}`);
        if (response.data?.data) {
          this.enabled = true;
          this.podcast_website = response.data.data;
        }
      } catch (error) {
        if (error.response.status !== 404) {
          // 404 is the response if it's not enabled. Any other 'error' display it.
          window.handleAxiosError(error);
        }
      }
    },
    async updatePodcastWebsite() {
      try {
        const response = await axios.patch(`/api/v1/podcast-websites/${this.podcast_website.id}`, this.podcast_website);
        this.podcast_website = response.data.data;
        window.toastr.success("Podcast Website configuration updated");
      } catch (error) {
        this.handleAxiosError(error);
      }
    },
  },
};
